import {
  ExpandableSection,
  ExpandableSectionSummary,
  DimensionChipSelector,
  FormFieldLayout,
} from "components/common/wintForms";
import { DimensionEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { LocalizationHelperInstance } from "utils/helpers";
import { useDimensionMaps } from "components/common";
import { ReceiptTodoDimensionSectionProps } from "models/propTypes/receiptPropTypes";

const ReceiptTodoDimensionSection: React.FC<ReceiptTodoDimensionSectionProps> = ({
  connect,
  expandableStepProps,
  fileViewer,
  values,
}) => {
  const { forcedDimensionMap } = useDimensionMaps(DimensionEnums.DimensionCategory.Receipt);
  const dimensionsOptional = forcedDimensionMap.length === 0;

  const dimensionFieldConnect = connect("dimensions");

  return (
    <ExpandableSection
      summary={
        <ExpandableSectionSummary
          title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Tags)}
          subText={
            dimensionsOptional
              ? LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Optional)
              : undefined
          }
        />
      }
      initiallyOpen={!dimensionsOptional}
      hasErrors={dimensionFieldConnect.hasErrors}
      {...expandableStepProps}
    >
      <DimensionChipSelector
        {...dimensionFieldConnect}
        type={DimensionEnums.DimensionCategory.Receipt}
        allowDefaultDimensions
        amount={values.amount ?? 0}
        currency={values.currency ?? ""}
        layout={<FormFieldLayout direction="vertical" />}
        fileViewer={fileViewer}
      />
    </ExpandableSection>
  );
};

export default ReceiptTodoDimensionSection;
